export default __webpack_public_path__ + "static/media/kaskoop.645e88d0.png";